import { Popup } from 'models/popup';
import {Agent, request} from './base';

export class PopupsAgent extends Agent<Popup> {
    constructor() {
        super(Popup, '/popups');
    }

    sync = async () => {
        await request.post('/popups/sync', {});
    };

    clone = async (id: number, name: string) => {
        await request.post('/popups/clone', {id, name});
    };
}
